import { useEffect, useState } from 'react';

/**
 * Returns screen width, height, and whether the screen is considered mobile.
 */
export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
    isMobile: undefined,
  });

  useEffect(() => {
    function handleResize() {
      const isMobile = window.innerWidth <= 768;
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile,
      });
    }

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}
